export const extractFileName = (url?: string): string =>
  url ? url.substring(url.lastIndexOf('/') + 1) : ''
